module.exports = __webpack_public_path__ + "img/icon-fb.73f5b75c.svg";